import React, { Fragment } from 'react'
import './style.css'

export default ({ children }) => <div style={{ fontFamily: "'Rubik', 'Arial', sans-serif" }}>{children}</div>
